const config = {
  BASE_API: 'https://ife-api.cinesendstaging.com/api/'
}

export default config